import { PORTABLE_TEXT_FIELDS } from './snippets';

export const getProductAlertById = `//groq
  *[_type == "productAlert" 
  && !(_id in path("drafts.**")) 
  && dateTime(startsAt) < dateTime(now())
  && dateTime(expiresAt) > dateTime(now())
  && count((appliesTo[]->productId)[@  == $id]) > 0
  ] | order(priority desc) [0]
  {
    "content": content[] {
      ${PORTABLE_TEXT_FIELDS}
    }
  }
`;

export const getCategoryAlertById = `//groq
  *[_type == "productAlert" 
  && !(_id in path("drafts.**")) 
  && dateTime(startsAt) < dateTime(now())
  && dateTime(expiresAt) > dateTime(now())
  && count((appliesTo[]->_id)[@  == $id]) > 0
  ] | order(priority desc)[0]
  {
    "content": content[] {
      ${PORTABLE_TEXT_FIELDS}
    }
  }
`;

export const headerAlertFields = `//groq
  _id,
  "content": content[] {
    ${PORTABLE_TEXT_FIELDS}
  },
`;

export const getCombinedHeaderQuery = `//groq
{
  "alerts": {
    "override": *[_type == "headerTextAlert" 
      && !(_id in path("drafts.**")) 
      && dateTime(startsAt) < dateTime(now())
      && (expiresAt == null || dateTime(expiresAt) > dateTime(now())) 
      && singleOverride == true 
    ] {
      ${headerAlertFields}
    },
    "banter": *[_type == "headerTextAlert" 
        && !(_id in path("drafts.**")) 
        && dateTime(startsAt) < dateTime(now()) 
        && (expiresAt == null || dateTime(expiresAt) > dateTime(now())) 
        && bulkBanterOnly == true 
        && $isBanter 
        && singleOverrideApp != true 
        && appOnly != true] | order(_updatedAt desc)
      {
        ${headerAlertFields}
      },
    "loggedIn": *[_type == "headerTextAlert" 
        && !(_id in path("drafts.**")) 
        && dateTime(startsAt) < dateTime(now()) 
        && (expiresAt == null || dateTime(expiresAt) > dateTime(now()))
        && loggedInOnly == true 
        && $isLoggedIn 
        && singleOverrideApp != true 
        && appOnly != true] | order(_updatedAt desc)
      {
        ${headerAlertFields}
      },
    "general": *[_type == "headerTextAlert" 
        && !(_id in path("drafts.**")) 
        && dateTime(startsAt) < dateTime(now()) 
        && (expiresAt == null || dateTime(expiresAt) > dateTime(now())) 
        && bulkBanterOnly != true
        && loggedInOnly != true 
        && singleOverrideApp != true 
        && appOnly != true] | order(_updatedAt desc)
      {
        ${headerAlertFields}
      }
  },
  "links": *[_type == "marketingCopy"] {
    "left": {
      "message": leftMessage,
      "link": coalesce(leftLink->slug.current, leftFallback.current)
    },
    "right": {
      "message": rightMessage,
      "link": coalesce(rightLink->slug.current, rightFallback.current)
    }
  }
}`;
